import { useEffect, useState } from "react";

import AselLogo from "./../../img/AselLogo.png";
import GenericProfile from "./../../img/GenericProfile.png";
import axios from "axios";
import { io } from "socket.io-client";
import { DarkThemeToggle } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { ErrorInfo } from "../utils/ErrorInfo";
import { LucideSignal, RailSymbolIcon } from "lucide-react";
const profileDropdownStyle = {
  position: "fixed",
  top: "55px", // Adjust this value as needed
  right: "10px", // Adjust this value as needed
  margin: "0px",
  width: "170px",
  zIndex: "50", // Ensure it's on top
};

export default function NavbarCommercial() {
  const [roleId, setRoleId] = useState(null);
  const [username, setUsername] = useState("");
  const [commercial, setCommercial] = useState(null);
  const [notifications, setNotification] = useState([]);

  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  const [error, setError] = useState("");

  const [errorInfo, setErrorInfo] = useState({
    isVisible: false,
    errorMessage: "",
  });

  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
  };

const toggleSidebar = () => {
  if (window.innerWidth < 768) {
    setSidebarOpen(prev => !prev);
  }
};

const closeSidebarOnMobile = () => {
  if (window.innerWidth < 768) {
    setSidebarOpen(false);
  }
};

  const navigate = useNavigate();

  const getfullinfo = async (event) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/check/`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        setUsername(response.data.user.username);
        setRoleId(response.data?.data?._id);
        const CommercialInfoResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}commercial/${response.data?.data?._id}/`,
          { withCredentials: true }
        );
        setCommercial(CommercialInfoResponse.data);
      }
    } catch (error) {
      setError(error.response.data.message);
      setErrorInfo({
        isVisible: true,
        errorMessage: error.response.data.message,
      });
    }
  };

  const handleLogout = async (event) => {
    event.preventDefault();
    setError(""); // Clear any previous errors
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/logout/`,
        { withCredentials: true }
      );

      if (response.status === 200) {
        // Successful logout
        navigate("/login");
      } else {
        setError("Erreur");
      }
    } catch (error) {
      setError("Erreur: " + (error.response?.data?.message || error.message));
    }
  };

  useEffect(() => {
    if (window.innerWidth < 768) {
      setSidebarOpen(false);
    }
    getfullinfo();
  }, []);
  const fetchNotificationss = async (page = 1, search = "") => {
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_BACKEND_URL
        }relatedNotifications/?page=${1}&limit=${3000}&search=${"false"}`,
        { withCredentials: true }
      );
      setNotification(response.data.data);
      //play notification sound from the folder common/notificatio.wav
      // const audio = new Audio(process.env.REACT_APP_BASE_URL + "/common/notificatio.wav");
      // audio.play();
     
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchNotificationss();
    if (commercial) {
      const newSocket = io(process.env.REACT_APP_BASE_URL, {
        withCredentials: true,
        transports: ["websocket"],
      });

      newSocket.on("connect", () => {
        console.log("Socket connected successfully");
        newSocket.emit("joinSocketServer");
      });
      newSocket.on("notification", (data) => {
        setNotification((prev) => {
          return [...prev, data];
        });
      });

      newSocket.on("connect_error", (error) => {
        console.error("Socket connection error:", error.message);
      });

      newSocket.on("error", (error) => {
        console.error("Socket error:", error);
      });

      return () => {
        if (newSocket) {
          console.log("Cleaning up socket connection");
          newSocket.disconnect();
        }
      };
    }
  }, [commercial]);

  return (
    <>
      {errorInfo.isVisible && (
        <ErrorInfo
          onClose={() => setErrorInfo({ ...errorInfo, isVisible: false })}
          errorMessage={error}
        />
      )}
      {commercial !== null && (
        <>
          <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700">
            <div className="px-3 py-3 lg:px-5 lg:pl-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center justify-start rtl:justify-end">
                  <button
                    onClick={toggleSidebar}
                    data-drawer-target="logo-sidebar"
                    data-drawer-toggle="logo-sidebar"
                    aria-controls="logo-sidebar"
                    type="button"
                    className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                  >
                    <span className="sr-only">Open sidebar</span>
                    <svg
                      className="w-6 h-6"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        clipRule="evenodd"
                        fillRule="evenodd"
                        d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                      ></path>
                    </svg>
                  </button>
                  <a href="/" className="flex ms-2 md:me-24">
                    <img src={AselLogo} className="h-8 me-2" alt="Asel Logo" />
                    <span className="hidden md:block self-center text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-white">
                      Stock Manager
                    </span>
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <div>
                  <DarkThemeToggle />
                  </div>
                  <div>
                    <button
                      onClick={() => {
                        closeSidebarOnMobile();
                        navigate("/alerts");
                      }}
                      type="button"
                      data-dropdown-toggle="notification-dropdown"
                      className="relative p-2 text-gray-500 rounded-lg hover:text-gray-900 hover:bg-gray-100 dark:text-gray-400 dark:hover:text-white dark:hover:bg-gray-700"
                    >
                      <span className="sr-only">View alerts</span>
                      <svg
                        className="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"></path>
                      </svg>
                      {notifications.length >= 1 ? (
                        <span className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-sm font-medium text-red-800 bg-red-100 rounded-full dark:bg-red-900 dark:text-red-300">
                          {notifications.length}
                        </span>
                      ) : null}
                    </button>
                  </div>
                  <div className="hidden md:block md:flex md:flex-col items-start justify-center text-xs text-slate-500">
                    <span>{username}</span>
                    <span>Commercial</span>
                  </div>
                  <button
                    onClick={toggleProfileDropdown}
                    type="button"
                    className="flex text-sm rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                    aria-expanded="false"
                    data-dropdown-toggle="dropdown-user"
                  >
                    <span className="sr-only">Open user menu</span>

                    <img
                      className="w-8 h-8 rounded-full"
                      src={GenericProfile}
                      alt="user photo"
                    ></img>
                  </button>

                  <div
                    className={`${
                      isProfileDropdownOpen ? "block" : "hidden"
                    } z-50 my-4 text-base list-none bg-white divide-y divide-gray-100 rounded shadow dark:bg-gray-700 dark:divide-gray-600`}
                    id="dropdown-user"
                    style={profileDropdownStyle}
                    data-popper-placement="bottom"
                  >
                    <div className="px-4 py-3" role="none">
                      <p
                        className="text-sm text-gray-900 dark:text-white"
                        role="none"
                      >
                        {username}
                      </p>
                      {commercial && (
                        <p
                          className="text-sm font-medium text-gray-900 truncate dark:text-gray-300"
                          role="none"
                        >
                          {commercial.Email}
                        </p>
                      )}
                    </div>
                    <ul className="py-1" role="none">
                      <li>
                        <a
                          href="/"
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                          role="menuitem"
                        >
                          Dashboard
                        </a>
                        <a
                          href="/settings"
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                          role="menuitem"
                        >
                          Paramètres
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          onClick={handleLogout}
                          className="block px-4 py-2 text-sm text-red-700 hover:bg-red-100 dark:text-red-300 dark:hover:bg-red-600 dark:hover:text-red"
                          role="menuitem"
                        >
                          Déconnection
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          <aside
            id="logo-sidebar"
            className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform ${
              isSidebarOpen ? "translate-x-0" : "-translate-x-full"
            } bg-white border-r border-gray-200 dark:bg-gray-800 dark:border-gray-700`}
            aria-label="Sidebar"
          >
            <div className="h-full px-3 pb-4 overflow-y-auto bg-white dark:bg-gray-800">
              <ul className="space-y-2 font-medium">
                <li>
                  <a
                    href="/"
                    className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <svg
                      className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 22 21"
                    >
                      <path d="M16.975 11H10V4.025a1 1 0 0 0-1.066-.998 8.5 8.5 0 1 0 9.039 9.039.999.999 0 0 0-1-1.066h.002Z" />
                      <path d="M12.5 0c-.157 0-.311.01-.565.027A1 1 0 0 0 11 1.02V10h8.975a1 1 0 0 0 1-.935c.013-.188.028-.374.028-.565A8.51 8.51 0 0 0 12.5 0Z" />
                    </svg>
                    <span className="ms-3">Dashboard</span>
                  </a>
                </li>
                <li>
                  <button
                    // onClick={toggleCommercialDropdown}
                    onClick={() => {
                      closeSidebarOnMobile();
                      navigate("/transactionsPage");
                    }}
                    type="button"
                    className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                    aria-controls="dropdown-example"
                    data-collapse-toggle="dropdown-example"
                  >
                    <RailSymbolIcon className="text-slate-500" />
                    <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                      Mes Transactions
                    </span>
                  </button>
                </li>
                <li>
                  <button
                    // onClick={toggleCommercialDropdown}
                    onClick={() => {
                      closeSidebarOnMobile();
                      navigate("/simsPage");
                    }}
                    type="button"
                    className="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-lg group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                    aria-controls="dropdown-example"
                    data-collapse-toggle="dropdown-example"
                  >
                    <LucideSignal className="text-slate-500" />
                    <span className="flex-1 ms-3 text-left rtl:text-right whitespace-nowrap">
                      Mes Sims
                    </span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      closeSidebarOnMobile();
                      navigate("/franchises", { state: { roleId: roleId } });
                    }}
                    type="button"
                    className="flex items-center w-full p-2 text-base font-semi-bold text-slate-900 rounded-lg hover:bg-gray-100 transition duration-75"
                  >
                    <svg
                      className="w-5 h-5 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.535 7.677c.313-.98.687-2.023.926-2.677H17.46c.253.63.646 1.64.977 2.61.166.487.312.953.416 1.347.11.42.148.675.148.779 0 .18-.032.355-.09.515-.06.161-.144.3-.243.412-.1.111-.21.192-.324.245a.809.809 0 0 1-.686 0 1.004 1.004 0 0 1-.324-.245c-.1-.112-.183-.25-.242-.412a1.473 1.473 0 0 1-.091-.515 1 1 0 1 0-2 0 1.4 1.4 0 0 1-.333.927.896.896 0 0 1-.667.323.896.896 0 0 1-.667-.323A1.401 1.401 0 0 1 13 9.736a1 1 0 1 0-2 0 1.4 1.4 0 0 1-.333.927.896.896 0 0 1-.667.323.896.896 0 0 1-.667-.323A1.4 1.4 0 0 1 9 9.74v-.008a1 1 0 0 0-2 .003v.008a1.504 1.504 0 0 1-.18.712 1.22 1.22 0 0 1-.146.209l-.007.007a1.01 1.01 0 0 1-.325.248.82.82 0 0 1-.316.08.973.973 0 0 1-.563-.256 1.224 1.224 0 0 1-.102-.103A1.518 1.518 0 0 1 5 9.724v-.006a2.543 2.543 0 0 1 .029-.207c.024-.132.06-.296.11-.49.098-.385.237-.85.395-1.344ZM4 12.112a3.521 3.521 0 0 1-1-2.376c0-.349.098-.8.202-1.208.112-.441.264-.95.428-1.46.327-1.024.715-2.104.958-2.767A1.985 1.985 0 0 1 6.456 3h11.01c.803 0 1.539.481 1.844 1.243.258.641.67 1.697 1.019 2.72a22.3 22.3 0 0 1 .457 1.487c.114.433.214.903.214 1.286 0 .412-.072.821-.214 1.207A3.288 3.288 0 0 1 20 12.16V19a2 2 0 0 1-2 2h-6a1 1 0 0 1-1-1v-4H8v4a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2v-6.888ZM13 15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="flex-1 ml-3 text-left whitespace-nowrap dark:text-white">
                      Mes franchises
                    </span>
                  </button>
                </li>
                <li>
                  <a
                    href="/alerts"
                    className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="m17.418 3.623-.018-.008a6.713 6.713 0 0 0-2.4-.569V2h1a1 1 0 1 0 0-2h-2a1 1 0 0 0-1 1v2H9.89A6.977 6.977 0 0 1 12 8v5h-2V8A5 5 0 1 0 0 8v6a1 1 0 0 0 1 1h8v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4h6a1 1 0 0 0 1-1V8a5 5 0 0 0-2.582-4.377ZM6 12H4a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2Z" />
                    </svg>
                    <span className="flex-1 ms-3 whitespace-nowrap">
                      Alertes
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="/settings"
                    className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
                  >
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      viewBox="0 0 20 18"
                    >
                      <path
                        fillRule="evenodd"
                        d="M17 10v1.126c.367.095.714.24 1.032.428l.796-.797 1.415 1.415-.797.796c.188.318.333.665.428 1.032H21v2h-1.126c-.095.367-.24.714-.428 1.032l.797.796-1.415 1.415-.796-.797a3.979 3.979 0 0 1-1.032.428V20h-2v-1.126a3.977 3.977 0 0 1-1.032-.428l-.796.797-1.415-1.415.797-.796A3.975 3.975 0 0 1 12.126 16H11v-2h1.126c.095-.367.24-.714.428-1.032l-.797-.796 1.415-1.415.796.797A3.977 3.977 0 0 1 15 11.126V10h2Zm.406 3.578.016.016c.354.358.574.85.578 1.392v.028a2 2 0 0 1-3.409 1.406l-.01-.012a2 2 0 0 1 2.826-2.83ZM5 8a4 4 0 1 1 7.938.703 7.029 7.029 0 0 0-3.235 3.235A4 4 0 0 1 5 8Zm4.29 5H7a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h6.101A6.979 6.979 0 0 1 9 15c0-.695.101-1.366.29-2Z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="flex-1 ms-3 whitespace-nowrap">
                      Paramètres
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={handleLogout}
                    className="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-red-100 dark:hover:bg-red-700 group"
                  >
                    <svg
                      className="flex-shrink-0 w-5 h-5 text-gray-500 transition duration-75 dark:text-red-400 group-hover:text-red-900 dark:group-hover:text-red"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 18 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M1 8h11m0 0L8 4m4 4-4 4m4-11h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-3"
                      />
                    </svg>
                    <span className="flex-1 ms-3 whitespace-nowrap group-hover:text-white-900">
                      Déconnection
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </aside>
        </>
      )}
    </>
  );
}
